import classNames from 'classnames';

export const filterDevicesByKind = (devices: MediaDeviceInfo[], kind: string) =>
  devices.filter(
    (device) => device.kind === kind && device.deviceId && device.deviceId !== 'default'
  );

export const pointClassName = (volume: number, size: number) =>
  classNames('leading-2 text-sm transition-all', volume > size ? 'text-blue' : 'text-black/10');
